<template>
  <div class="main">
    <div class="banner" :style=" 'background-image: url(' + this.banner + ');'"></div>
    <div class="service">
      <div class="service1">
        <p class="servicep">{{ischinese == "cn" ?this.newsarray.title:this.newsarray.title_en}}</p>
        <p class="servicep2">{{this.type_name}}&emsp;|&emsp;{{this.newsarray.time}}</p>

        <div class="servicep3" v-html="ischinese == 'cn' ?this.newsarray.content:this.newsarray.content_en"></div>
      </div>
      <div class="service4">
        <div>
          <span
            class="newsss"
            style=" -webkit-box-orient: vertical;"
            v-show="this.lastNew.image != null"
            @click="routerdetails(lastNew.id)"
          >{{one1}}：{{ischinese == "cn" ?this.lastNew.title:this.lastNew.title_en}}</span>
          <span
            class="newsss newss1"
            style=" -webkit-box-orient: vertical;"
            v-show="this.nextNew.image != null"
            @click="routerdetails(nextNew.id)"
          >{{one2}}：{{ischinese == "cn" ?this.nextNew.title:this.nextNew.title_en}}</span>
        </div>
        <div>
          <router-link to="mSchool">
            <div class="more">
              <i class="el-icon-arrow-left"></i>
              <i class="el-icon-arrow-left"></i>
              {{one3}}
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banner: "",
      newsarray: [],
      lastNew: [
        {
          image: null,
          title: null,
          id: null
        }
      ],
      nextNew: [
        {
          image: null,
          title: null,
          id: null
        }
      ],
      typelist: [
        { id: "", type_name: "" },
        { id: "", type_name: "" }
      ],
      type_name: "",
      one1: "前一篇",
      one2: "后一篇",
      one3: "返回"
    };
  },
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.one1 = "Last article";
      this.one2 = "Next article";
      this.one3 = "Return";
    }
    // console.log(this.$route.query)
    const id = this.$route.query.detailsid;
    // console.log(id)
    this.$http
      .post("/api/dashu/news/getInfo", {
        id: id
      })
      .then(res => {
        // console.log(res.data.data)
        if (res.data.code === 0) {
          const setting = res.data.data;
          this.banner = res.data.data.lists.image[0];
          this.newsarray = setting.lists;
          this.lastNew = setting.lastNew;
          this.nextNew = setting.nextNew;
          this.$http.post("/api/dashu/news/newTypeList", {}).then(res => {
            if (res.data.code === 0) {
              this.typelist = res.data.data.list;
              // console.log(res)
              for (var i = 0; i < this.typelist.length; i++) {
                var tttid = this.typelist[i].id;
                if (this.newsarray.type_id === tttid) {
                  this.type_name = this.typelist[i].type_name;
                }
              }
            }
          });
        }
      });
  },
  methods: {
    routerdetails(detailsid) {
      this.$router.push({
        name: "mDetail",
        query: { detailsid: detailsid }
      });
      this.$http
        .post("/api/dashu/news/getInfo", {
          id: detailsid
        })
        .then(res => {
          if (res.data.code === 0) {
            this.banner = res.data.data.lists.image[0];
            // console.log(res.data.data)
            const setting = res.data.data;
            this.newsarray = setting.lists;
            this.lastNew = setting.lastNew;
            this.nextNew = setting.nextNew;
            // console.log(this.lastNew)
            // console.log(this.nextNew)
          }
        });
    }
  }
};
</script>
<style scoped>
body {
  position: relative;
}
.banner {
  width: 100%;
  height: 7.6rem;
  position: relative;
  overflow: hidden !important;
  background-size: cover;
  background-repeat: no-repeat;

  background-position: center center;
}
.service {
  background: white;
  padding: 0.9rem 0.4rem 0;
}
.servicep {
  font-size: 0.48rem;
  text-align: left;
  font-weight: bold;
  margin: 0 0 0.6rem;
}
.servicep2 {
  font-size: 0.24rem;
  line-height: 0.3rem;
  text-align: left;
  color: #b2b2b2;
}
.servicep3 {
  font-size: 0.24rem;
  line-height: 0.3rem;
  padding-bottom: 0.9rem;
}
.more {
  background: white;
  color: #76c3a2;
  border: 1px solid #76c3a2;
  font-size: 0.18rem;
  line-height: 0.4rem;
  width: 1.4rem;
  height: 0.4rem;
  border-radius: 5px;
  padding-left: 0.1rem;
  margin-top: 0.2rem;
  position: absolute;
  right: 0;
}
.service4 {
  margin: 0 auto 30px;
  display: flex;
  position: relative;
}
.service1l {
  position: relative;
}
.newss1 {
  padding-top: 0.2rem;
}
.newsss {
  width: 5.5rem;
  padding-right: 0.4rem;
  color: black;
  font-size: 0.18rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/mbPages/mDetail.vue